<template>
  <div class="clinica" style="overflow-x: hidden">
    <home-clinic-header
      :imgLogo="cx_clinic.logo_url"
      style="flex: 1"
      :service="service"
      v-on:goToSchedule="openScheduleModal"
    />
    <clinic-message />
    <clinic-services />
    <side-modal
      v-if="cx_serviceModal && cx_serviceModal.modalOpened"
      :opened="cx_serviceModal.modalOpened"
      @close="closeModal($event)"
    >
      <service-appoint
        :cx_address="cx_clinic.street"
        :service="cx_serviceModal.selectedService"
        :opened="cx_serviceModal.modalOpened"
        @close="closeModal($event)"
      ></service-appoint>
    </side-modal>
  </div>
</template>

<script>
import HomeClinic from "./HomeClinic";
export default HomeClinic;
</script>
